/**
 * Tracking environment configuration.
 *
 * `GATSBY_TRACKING_ENV` is intentionally separate from NODE_ENV: a production
 * build used for a staging/preview deployment must not send events to the
 * commercial containers. The fallback preserves the existing public-site
 * behaviour until the deployment environment is explicitly configured.
 */
const configuredEnvironment = process.env.GATSBY_TRACKING_ENV;

export const TRACKING_ENV =
  configuredEnvironment || (process.env.NODE_ENV === "production" ? "production" : "development");

export const TRACKING_ENABLED =
  TRACKING_ENV === "production" && process.env.GATSBY_TRACKING_ENABLED !== "false";

const DEFAULT_TRACKING_HOSTS = ["mon5.eu", "www.mon5.eu"];
const configuredHosts = process.env.GATSBY_TRACKING_ALLOWED_HOSTS;

export const TRACKING_ALLOWED_HOSTS = Object.freeze(
  (configuredHosts ? configuredHosts.split(",") : DEFAULT_TRACKING_HOSTS)
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean)
);

export function isTrackingAllowedOnCurrentHost() {
  if (typeof window === "undefined") return false;
  return TRACKING_ALLOWED_HOSTS.includes(window.location.hostname.toLowerCase());
}

// Piani consigliati dal configuratore prodotti. Codici invarianti fra IT e EN:
// servono sia al configuratore sia al form contatti, che accetta solo questi
// valori come `recommended_tier`.
export const RECOMMENDED_TIERS = Object.freeze([
  "Assessment",
  "ESSENTIAL",
  "PROTECT",
  "ADVANCED",
]);

export const TRACKING_ENVIRONMENTS = Object.freeze({
  production: "production",
  staging: "staging",
  development: "development",
  disabled: "disabled",
});
